import { type Task, TaskStatus } from 'src/api/generated';

/**
 * Get the appropriate date to display for a task based on its status
 * Used by communications module for contextual date display
 */
export const getDisplayDate = (task: Task): string | null => {
  if (task.status === TaskStatus.COMPLETED && task.completedAt) {
    return task.completedAt;
  }
  if (task.status === TaskStatus.CANCELLED && task.cancelledAt) {
    return task.cancelledAt;
  }

  if (!task.dueDate) return null;
  return task.dueDate;
};

/**
 * Check if a task is overdue
 */
export const isTaskOverdue = (task: Task): boolean => {
  if (!task.dueDate) return false;
  if (
    task.status === TaskStatus.COMPLETED ||
    task.status === TaskStatus.CANCELLED
  ) {
    return false;
  }
  return new Date(task.dueDate) < new Date();
};

/**
 * Format date for display in different contexts
 */
export const formatTaskDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString();
};
